<rect width="32" height="32" fill="currentColor" rx="16" />
<path
    fill="var(--gw-rd-white-color)"
    d="M16.015 6.004c-5.248 0-9.496 4.049-9.496 8.996 0 2.599 1.15 4.898 2.999 6.547v4.448l3.898-2.349c.8.2 1.699.35 2.599.35 5.247 0 9.495-4.048 9.495-8.996 0-4.947-4.248-8.996-9.495-8.996Z"
/>
<path
    fill="currentColor"
    d="m10.925 17.332 4.241-4.665 2.12 2.12 3.818-2.12-4.241 4.665-2.12-2.12-3.818 2.12Z"
/>
